import { NavLink } from "react-router-dom"
import UserImage from "./UserImage"

export default function Avatar({
    displayName,
    guid
}) {

    // https://picsum.photos/seed/${user.guid}/60/60
    //https://ui-avatars.com/api/?name=John+Doe

    return (
        <NavLink to={{ pathname: "/dashboard/employees/see-employment" }} state={{ userGUID: guid }} className="btn btn-dark me-1">
            {/* <img className="rounded-circle" src={`https://ui-avatars.com/api/?name=${displayName.replace(" ", "+")}&background=random`}/> */}
            <UserImage guid={guid} />
            <br />
            {displayName}
        </NavLink>
    )
}